// extracted by mini-css-extract-plugin
export var boxItems = "_1c-1";
export var button = "_1c-5";
export var filterGroupBox = "_1c-0";
export var icon = "_1c-2";
export var iconSecondary = "_1c-4";
export var iconWrapper = "_1c-3";